
import './App.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import LogIn from './pages/LogIn';
import Register from './pages/Register';
import Onboarding from './pages/Onboarding';
import Dashboard from './pages/Dashboard';
import NewDashboard from './pages/NewDashboard';
import Orders from './pages/Orders';
import Setting from './pages/Setting';
import Category from './pages/Category';
import Menu from './pages/Menu';
import AddMenu from './pages/AddMenu';
import OrderDetail from './pages/OrderDetail';
import Vegetables from './pages/Vegetables';
import Groceries from './pages/Groceries';
import DairyItems from './pages/DairyItems';
import FarsanItems from './pages/FarsanItems';
import VasanItems from './pages/VasanItems';
import ViewMaterial from './pages/ViewMaterial';
import Farm from './pages/Farm';
import Miscellaneous from './pages/Miscellaneous';
import AddGroceriesPage from './pages/AddGroceriesPage';

import CommonLayout from './components/CommonLayout';
import ProtectedRoutes from './hooks/ProtectedRoutes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import { SkeletonTheme } from 'react-loading-skeleton';
import './i18n';
import { LoaderProvider } from './hooks/LoaderContext';
import Loader from './components/Loader';
import Report from './pages/Report';
import Caterers from './pages/Caterers';
import CatererProfile from './pages/CatererProfile';
import VerifyEmail from './pages/VerifyEmail';
import Profile from './pages/Profile';
import LandingPage from './pages/LandingPage';
import Pricing from './pages/Pricing';
import { changeLanguage } from './components/common';
import AddUpdateGroceriesSrtockPage from './pages/AddUpdateGroceriesSrtockPage';
import FarmCopy from './pages/Farm copy';
import VegetablesCopy from './pages/Vegetables copy';
import GroceriesCopy from './pages/Groceries copy';
import DairyItemsCopy from './pages/DairyItems copy';
import FarsanItemsCopy from './pages/FarsanItems copy';
import VasanItemsCopy from './pages/VasanItems copy';
import MiscellaneousCopy from './pages/Miscellaneous copy';


const queryClient = new QueryClient(
  {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  }
);

function App() {
  // Initialize language preference on app start
  useEffect(() => {
    try {
      const currentUser = JSON.parse(localStorage.getItem('CurrentUser'));
      if (currentUser?.preferredLanguage) {
        changeLanguage(currentUser.preferredLanguage);
      }
    } catch (error) {
      console.warn('Error initializing language:', error);
    }
  }, []);

  return (
    <LoaderProvider>
      <SkeletonTheme baseColor="#F3F4F8" highlightColor="#F9F9FB" borderRadius="2px">

        <QueryClientProvider client={queryClient}>
          <ToastContainer />
          <Loader />
          <Routes>
            <Route path="/login" element={<LogIn />} />
            <Route path="/register" element={<Register />} />
            <Route path="/onboarding" element={
              <ProtectedRoutes redirectTo="/login" checkOnboarding={false}>
                <Onboarding />
              </ProtectedRoutes>
            } />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/pricing" element={<Pricing />} />
            
            {/* SuperAdmin Routes */}
            {/* <Route path="/superadmin/login" element={<SuperAdminLogin />} />
            <Route path="/superadmin" element={
              <SuperAdminProtectedRoutes redirectTo="/superadmin/login">
                <SuperAdminLayout />
              </SuperAdminProtectedRoutes>
            }>
              <Route index path="dashboard" element={<SuperAdminDashboard />} />
              <Route path="users" element={<SuperAdminUsers />} />
              <Route path="caterers" element={<Caterers />} />
              <Route path="caterer-profile/:id" element={<CatererProfile />} />
              <Route path="roles" element={<SuperAdminRoles />} />
              <Route path="reports" element={<div className="p-6"><h1 className="text-2xl font-bold">System Reports</h1><p className="text-gray-600">System reports functionality coming soon...</p></div>} />
              <Route path="settings" element={<div className="p-6"><h1 className="text-2xl font-bold">System Settings</h1><p className="text-gray-600">System settings functionality coming soon...</p></div>} />
              <Route path="audit" element={<div className="p-6"><h1 className="text-2xl font-bold">Audit Logs</h1><p className="text-gray-600">Audit logs functionality coming soon...</p></div>} />
            </Route> */}
            <Route path={"/"} element={
              <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                <CommonLayout />
              </ProtectedRoutes>
            }>
              {/* <Route index path={'dashboard'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <Dashboard />
                </ProtectedRoutes>}
              /> */}

              <Route index path={'dashboard'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <NewDashboard />
                </ProtectedRoutes>}
              />

              <Route index path={'Category'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <Category />
                </ProtectedRoutes>}
              />

              <Route index path={'menu'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <Menu />
                </ProtectedRoutes>}
              />

              <Route index path={'addmenu'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <AddMenu />
                </ProtectedRoutes>}
              />

              <Route index path={'orders'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <Orders />
                </ProtectedRoutes>}
              />

              <Route index path={'order-details'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <OrderDetail />
                </ProtectedRoutes>}
              />
              <Route index path={'vegetable'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <VegetablesCopy />
                </ProtectedRoutes>}
              />

              <Route index path={'groceries'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <GroceriesCopy />
                </ProtectedRoutes>}
              />

              <Route index path={'groceries/add'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <AddGroceriesPage />
                </ProtectedRoutes>}
              />

              <Route index path={'groceries/add-update-stock'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <AddUpdateGroceriesSrtockPage />
                </ProtectedRoutes>}
              />

              <Route index path={'dairyitems'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <DairyItemsCopy />
                </ProtectedRoutes>}
              />

              <Route index path={'farsanitems'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <FarsanItemsCopy />
                </ProtectedRoutes>}
              />

              <Route index path={'vasanItems'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <VasanItemsCopy />
                </ProtectedRoutes>}
              />

              <Route index path={'setting'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <Setting />
                </ProtectedRoutes>}
              />

              <Route index path={'farm'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <FarmCopy />
                </ProtectedRoutes>}
              />
              <Route index path={'report'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <Report />
                </ProtectedRoutes>}
              />

              <Route index path={'miscellaneous'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <MiscellaneousCopy />
                </ProtectedRoutes>}
              />

              <Route index path={'profile'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <Profile />
                </ProtectedRoutes>}
              />
               <Route index path={'caterer-profile'} element={
                <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                  <CatererProfile />
                </ProtectedRoutes>}
              />

              <Route path={'/'} element={<Navigate to="/dashboard" replace />} />
            </Route>

            <Route path="/viewMaterial" element={
              <ProtectedRoutes redirectTo="/login" checkOnboarding={true}>
                <ViewMaterial />
              </ProtectedRoutes>} />
          </Routes>
        </QueryClientProvider>
      </SkeletonTheme>
    </LoaderProvider>
  );
}

export default App;


